import { getRequest } from '../services/requestHandler';
import { AppUserMenu } from '../models';

export const getAppUserMenus = async (userId: string) => {
  const url = `app/getAppUserMenus?appUserId=${userId}`;

  const response = await getRequest<AppUserMenu>('GetAppUserMenus', url);
  return response;
};
